import { RefCallback } from "react";

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

export const BRANDS = [
  "RH",
  "MO",
  "BC",
  "TN",
  "SH",
  "BH",
  "OD",
  "IN",
  "CN",
  "INT"
] as const;
export type Brand = typeof BRANDS[number];

export type UserContext = {
  country: string;
  userType: string;
  currencyCode: string;
  cartId?: Maybe<string>;
  userId?: Maybe<string>;
  shopperRef?: Maybe<string>;
  email?: Maybe<string>;
  [key: string]: any;
};

export type MetaData = {
  [key: string]: {
    id: Scalars["String"] | Scalars["Int"];
    label: Scalars["String"];
    alt1?: Scalars["String"];
    sortPriority?: Scalars["Int"];
  };
};

export type AdyenResultState = {
  data: {
    details: { [type: string]: string | Record<string, string> };
  };
};

export type RHGenericHTMLAttributes = Partial<React.HTMLProps<HTMLElement>>;

export type RHReferenceableComponentProps = {
  /**
   * To be used by containers, when we need to capture the DOM element of each child.
   * We can use a ref callback in case the child component is a forwardRef.
   */
  domRefCallback?: RefCallback<any>;

  /**
   * Any HTML attribute to spread in the root DOM element.
   */
  extraHTMLAttributes?: RHGenericHTMLAttributes;
};
